import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Employer } from '../../../../models/employers/employer';

@Component({
  selector: 'app-employer-record-overview-card-review-grid',
  templateUrl: './employer-record-overview-card-review-grid.component.html',
  styleUrls: ['./employer-record-overview-card-review-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordOverviewCardReviewGridComponent {
  @Input({ required: true }) employer!: Employer;
}
